import { createContext } from "react";
import {
  ChangeTaskSettingsAction,
  TasksSettings,
} from "./tasksSettingsReducer";

type TasksContextType = {
  tasksSettings: TasksSettings;
  dispatch: (action: ChangeTaskSettingsAction) => void;
};

export const TasksSettingsContext = createContext<TasksContextType>({
  tasksSettings: {
    markAsCompleted: false,
    markAsPriority: false,
  },
  dispatch: () => {},
});
